import {
    toggleVideoModal,
    FETCH_ACTIVE_TRAINING_MATERIAL_REQUESTED,
    FETCH_ACTIVE_TRAINING_MATERIAL_SUCCESS,
    FETCH_ACTIVE_TRAINING_MATERIAL_ERROR
} from '../actions/trainingActions.js';

// Upload Training Material action types (from createServiceAction pattern)
const UPLOAD_TRAINING_MATERIAL_LOADING = 'UPLOADTRAININGMATERIAL_LOADING';
const UPLOAD_TRAINING_MATERIAL_SUCCESS = 'UPLOADTRAININGMATERIAL_SUCCESS';
const UPLOAD_TRAINING_MATERIAL_ERROR = 'UPLOADTRAININGMATERIAL_ERROR';
const UPLOAD_TRAINING_MATERIAL_RESET = 'UPLOADTRAININGMATERIAL_RESET';

const defaultState = {
    isVideoModalOpen: false,
    activeTrainingMaterial: {
        loading: false,
        data: null,
        error: null
    },
    uploadTrainingMaterial: {
        loading: false,
        data: null,
        error: null
    }
};

export default function trainingReducer(state = defaultState, action) {
    switch (action.type) {
        case toggleVideoModal.type:
            return { ...state, isVideoModalOpen: action.payload };

        case FETCH_ACTIVE_TRAINING_MATERIAL_REQUESTED:
            return {
                ...state,
                activeTrainingMaterial: {
                    loading: true,
                    data: null,
                    error: null
                }
            };

        case FETCH_ACTIVE_TRAINING_MATERIAL_SUCCESS:
            return {
                ...state,
                activeTrainingMaterial: {
                    loading: false,
                    data: action.payload,
                    error: null
                }
            };

        case FETCH_ACTIVE_TRAINING_MATERIAL_ERROR:
            return {
                ...state,
                activeTrainingMaterial: {
                    loading: false,
                    data: null,
                    error: action.payload
                }
            };

        case UPLOAD_TRAINING_MATERIAL_LOADING:
            return {
                ...state,
                uploadTrainingMaterial: {
                    loading: true,
                    data: null,
                    error: null
                }
            };

        case UPLOAD_TRAINING_MATERIAL_SUCCESS:
            return {
                ...state,
                uploadTrainingMaterial: {
                    loading: false,
                    data: action.data,
                    error: null
                }
            };

        case UPLOAD_TRAINING_MATERIAL_ERROR:
            return {
                ...state,
                uploadTrainingMaterial: {
                    loading: false,
                    data: null,
                    error: action.data
                }
            };

        case UPLOAD_TRAINING_MATERIAL_RESET:
            return {
                ...state,
                uploadTrainingMaterial: {
                    loading: false,
                    data: null,
                    error: null
                }
            };

        default:
            return state;
    }
}

// Selectors - Active Training Material
export const selectActiveTrainingMaterial = state => state.training.activeTrainingMaterial;
export const selectActiveTrainingMaterialLoading = state => state.training.activeTrainingMaterial.loading;
export const selectActiveTrainingMaterialData = state => state.training.activeTrainingMaterial.data;
export const selectActiveTrainingMaterialError = state => state.training.activeTrainingMaterial.error;

// Selectors - Upload Training Material
export const selectUploadTrainingMaterial = state => state.training.uploadTrainingMaterial;
export const selectUploadTrainingMaterialLoading = state => state.training.uploadTrainingMaterial.loading;
export const selectUploadTrainingMaterialData = state => state.training.uploadTrainingMaterial.data;
export const selectUploadTrainingMaterialError = state => state.training.uploadTrainingMaterial.error;

